var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Calendar',{attrs:{"showTime":false,"locale":_vm.sv,"selectOtherMonths":true,"showButtonBar":true,"dateFormat":"yy-mm-dd"},model:{value:(_vm.theDate),callback:function ($$v) {_vm.theDate=$$v},expression:"theDate"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39443bf0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vfg-custom-fields/fieldFormattedDatePicker.vue
// module id = null
// module chunks = 